<div *ngFor="let status of statuses" class="d-flex justify-content-between p-1">
    <div class="w-100 d-flex justify-content-between">
        <span class="m--font-boldest text-nowrap-ellipsis mr-2">{{ status?.label | paperName }}</span>
        <div
            class="text-nowrap"
            [ngClass]="{
                'm--font-danger': !status.completed,
                'm--font-success': status.completed
            }"
        >
            {{ status?.statusText }}
        </div>
    </div>
</div>
